import React from 'react';
import type { StagedClient } from './AddClient';
import styles from '../../../styles/ListingManagement.module.css';
import buttonStyles from '../../../styles/Buttons.module.css';

interface ClientListProps {
  clients: StagedClient[];
  onRemove: (tempId: string) => void;
}

const ClientList: React.FC<ClientListProps> = ({ clients, onRemove }) => {
  if (clients.length === 0) {
    return <p className={styles.transactionEmpty}>No clients added yet.</p>;
  }

  return (
    <div className={styles.stagedClientListVertical}>
      {clients.map(client => (
        <div key={client.tempId} className={styles.stagedClientCard}>
          <div className={styles.stagedClientCardLabel}>{client.clientTypeName}</div>

          <div className={styles.stagedClientCardField}>
            <span className={styles.stagedClientCardFieldLabel}>Name:</span>
            <span className={styles.stagedClientCardFieldValue}>
              {client.name} {client.surname}
            </span>
          </div>

          <div className={styles.stagedClientCardField}>
            <span className={styles.stagedClientCardFieldLabel}>Email:</span>
            <span className={styles.stagedClientCardFieldValue}>{client.email}</span>
          </div>

          <div className={styles.stagedClientCardField}>
            <span className={styles.stagedClientCardFieldLabel}>Cell:</span>
            <span className={styles.stagedClientCardFieldValue}>{client.cell}</span>
          </div>

          <div className={styles.stagedClientCardField}>
            <span className={styles.stagedClientCardFieldLabel}>Address:</span>
            <span className={styles.stagedClientCardFieldValue}>
              {client.streetNumber} {client.streetName}, {client.city}
            </span>
          </div>

          <div className={styles.stagedClientCardField}>
            <span className={styles.stagedClientCardFieldLabel}>Marital Status:</span>
            <span className={styles.stagedClientCardFieldValue}>{client.maritalStatus}</span>
          </div>

          <div className={styles.stagedClientCardField}>
            <span className={styles.stagedClientCardFieldLabel}>Documents:</span>
            <span className={styles.stagedClientCardFieldValue}>
              {client.documents.length > 0
                ? client.documents.map(d => d.documentTypeName).join(', ')
                : <em>None</em>}
            </span>
          </div>

          <div style={{ marginTop: 10 }}>
            <button
              type="button"
              className={`${buttonStyles.button} ${buttonStyles.danger}`}
              onClick={() => onRemove(client.tempId)}
            >
              Remove
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClientList;
